import { render, staticRenderFns } from "./ReferencesDetails.vue?vue&type=template&id=054c6363&scoped=true&"
import script from "./ReferencesDetails.vue?vue&type=script&lang=js&"
export * from "./ReferencesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054c6363",
  null
  
)

export default component.exports